<template>
    <div class="">
        <div class="report-content">
            <h3>
                <span class="badge bg-success" v-if="report.status == 0"># {{ report.ID }}</span>
                <span class="badge bg-danger" v-if="report.status == 1"># {{ report.ID }}</span>
                <span class="badge bg-warning" v-if="report.status == 2"># {{ report.ID }}</span>
                {{ report.title }}
            </h3>
            <div id="vuln" role="tabpanel">
                <div class="row">
                    <div class="col-md-12">
                        <table class="report" v-bind:class="{'resolved' : !report.status}">
                            <tr>
                                <th>IMPACT</th>
                                <th>LIKELIHOOD</th>
                                <th>RISK</th>
                                <th>FIX EFFORT</th>
                            </tr>
                            <tr>
                                <td>{{ report.impact }}</td>
                                <td>{{ report.likelihood }}</td>
                                <td>{{ report.risk }}</td>
                                <td>{{ report.fixeffort }}</td>
                            </tr>
                            <tr>
                                <th>VULNERABILITY</th>
                                <td colspan="3">{{ report.summary }}</td>
                            </tr>
                            <tr>
                                <th>REASON</th>
                                <td colspan="3">{{ report.explanation }}</td>
                            </tr>
                            <tr>
                                <th>ACTION</th>
                                <td colspan="3">
                                    <ul class="removeBullet">
                                        <li v-for="(i, v) in report.action" :key="v">
                                            <div class="">
                                                <div v-if='(i.title).indexOf("[sub]") < 0' :index="a_index = 0">
                                                    <span>{{ v+1 + '. ' + i.title }}</span>
                                                </div>
                                                <div class="subcat" v-else>
                                                    <span class="ms-4">{{ i.title.replace("[sub]", alpha[a_index++] + ".  ") }}</span>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </td>
                            </tr>
                            <tr>
                                <th>FURTHER INFORMATION</th>
                                <td colspan="3">
                                    <ul class="removeBullet">
                                        <li v-for="(i, v) in report.further" :key="v">
                                            <div class="">
                                                <div v-if='(i.title).indexOf("[sub]") < 0' :index="a_index = 0">
                                                    <span>{{ v+1 + '. ' + i.title }}</span>
                                                </div>
                                                <div class="subcat" v-else>
                                                    <span class="ms-4">{{ i.title.replace("[sub]", alpha[a_index++] + ".  ") }}</span>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </td>
                            </tr>
                        </table>
                        <div class="evidence mt-3 mb-3" v-if="Object.keys(report.picture).length !== 0">
                            <h3>Evidence</h3>
                            <div class="row">
                                <div v-for="pic in report.picture" class="col-md-3" :key="pic.ID">
                                    <div class="card">
                                        <div v-if="pic.file_type == 'video/mp4'">
                                            <div class="playvideo" v-on:click="getSource(pic.picture, 'video')">
                                                <video src="" class="w-100 evidence-assets" controls></video>
                                                <div class="play-button">
                                                    <i class="fa fa-play"></i>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-else>
                                            <img
                                                v-if="pic.picture != ''"
                                                :src="pic.picture"
                                                v-on:click="getSource(pic.picture, 'image')"
                                                class="img-fluid m-auto evidence-assets">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
              </div>

            <div class="card mt-4">
                <div class="card-header">
                    <h3>Request a Retest or Comments</h3>
                </div>
                <div class="card-body">
                    <div class="alert alert-info">If you'd like to request a retest or add comments, please fill out the form below.</div>
                    <div class="">
                        <div class="contact">
                            <ul v-if="commentList.length > 0" class="list-group">
                                <li v-for="c in commentList" :key="c.ID" class="comlist list-group-item">
                                    <div>
                                        <div class="comments">
                                            <div class="cheader text-muted">

                                                <a href="#">{{ c.user }}</a>
                                                <span v-if="c.type == 1"> posted a <span class="me-2 ms-2 badge bg-info">comment</span></span>
                                                <span v-else-if="c.type == 2"> requested a <span class="me-2 ms-2 badge bg-warning">retest</span></span>
                                                <span v-else-if="c.type == 3"> marked vulnerability as <span class="me-2 ms-2 badge bg-success">resolved</span></span>
                                                <span v-else-if="c.type == 4"> changed the status to <span class="me-2 ms-2 badge bg-danger">Vulnerable</span></span>

                                                <span class="pull-right">{{ formattedTimestamp(c.CreatedAt) }}</span>
                                            </div>
                                            <div class="cbody">
                                                {{ c.content }}
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div class="mt-4">

                            <div class="form-group">
                                <select class="form-select mb-3" v-model="comment.type">
                                    <option value="1">Comments</option>
                                    <option value="2">Request a Retest</option>
                                    <option value="3" v-if="isSuperAdmin || isPentester">Mark as Resolved</option>
                                    <option value="4" v-if="isSuperAdmin || isPentester">Mark as Vulnerable</option>
                                </select>
                            </div>

                            <div class="form-group">
                                <textarea rows="3" class="form-control" v-model="comment.content"></textarea>
                            </div>
                            <div class="mt-3">
                                <button class="btn text-light btn-info btn-sm" v-on:click="commentSubmit()">Submit</button>
                            </div>
                        </div>
                    </div>
                </div>
                <p data-toggle="modal" data-bs-toggle="modal" data-bs-target="#viewAssets" id="popupModals"></p>
                <!-- view assets -->
                <div class="modal" id="viewAssets" tabindex="-1">
                    <div class="modal-dialog modal-xl">
                        <div class="modal-content">
                            <div class="modal-header">

                                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="closeModal"></button>
                            </div>
                            <div class="modal-body">
                                <div v-if="assetType == 'video'">
                                    <video :src="rawAssets" class="w-100" controls></video>
                                </div>
                                <div v-else>
                                    <img :src="rawAssets" class="w-100">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </div>

        </div>


</template>
<script>
// let a_index = 0;
import moment from 'moment'
import axios from 'axios'
import { mapGetters } from 'vuex'
export default {
    computed: {
      ...mapGetters({
        isSuperAdmin: 'auth/isSuperAdmin',
        isPentester: 'auth/isPentester'
      })
    },
    props: {
        report_id: Number,
    },
    data() {
         return {
             alpha: ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'],
             reload: 0,
             report: {
                picture: []
             },
             comment: {
                 type : 2,
                 content: ''
             },
             commentList : {},
             user_list: [],
            rawAssets: null,
            assetType: null
         }
     },

    mounted() {
         this.init();
    },

     methods : {
        getSource(asset_id, type) {
            this.rawAssets = asset_id;
            this.assetType = type;
            document.getElementById("popupModals").click();
        },
        formattedTimestamp(date) {
          const momentObj = moment(date);
          const now = moment();
          if (now.diff(momentObj) < 60000) {
            return 'now';
          } else {
            return momentObj.from(now);
          }
        },
        init: function() {
            // load weakness
            const me = this;
            if (this.report_id != 0) {
                this.$axios.get(this.$server + 'organisation/'+ this.$route.params.org_id +'/project/'+  me.$route.params.prod_id +'/report/' + me.report_id)
                .then(res => {
                    if (res.data.success) {
                        me.report = res.data.report[0];
                    }
                });

                this.$axios.get(this.$server + 'organisation/'+ this.$route.params.org_id +'/project/'+  me.$route.params.prod_id +'/report/' + me.report_id + '/comment')
                .then(res => {
                    if (res.data.success) {
                        me.commentList = res.data.data;
                    }
                });

                this.$axios.get(this.$server + 'organisation/' + this.$route.params.org_id)
                .then(res => {
                    if (res.data.success) {
                        var usr = res.data.users;
                        var obj_usr = {};
                        if (usr != undefined) {
                            for (var u = 0; u < usr.length; u++) {
                                var id = usr[u].user_id;
                                obj_usr[id] = usr[u].user.first_name;
                            }
                        }

                        me.user_list = obj_usr;
                    }
                });
            }
        },

        commentSubmit: function() {
            const me = this;
            this.comment.type = parseInt(this.comment.type);
            if (this.comment.type == 1 && this.comment.content == '') {
                this.$swal({
                    title: 'Posting comments required content',
                    icon: 'error'
                });
            } else {
                axios({
                    method: 'post',
                    url: this.$server + 'organisation/'+ this.$route.params.org_id +'/project/'+  me.$route.params.prod_id +'/report/' + me.report_id + '/comment',
                    data: this.comment
                })
                .then(res => {
                    if (res.data.success) {
                        me.init();
                        me.comment = {
                            'type' : 1,
                            'content' : ''
                        }
                    }
                });
            }
        },

        submitCallback(res) {
            if (res) {
                this.reload = Math.random();
                this.init();
            }
        },

        markReport: function(id, status, action = "action") {
            var isConfirm = false;
            const me = this;
            var stat = {};
            var url = this.$server + 'organisation/'+ this.$route.params.org_id +'/project/'+  me.$route.params.prod_id +'/report/' + me.report_id + '/action/' + id + '/status';
            if (status == 1) {
                isConfirm = confirm("Are you sure you want to mark this as resolved?");
                stat = {"status" : 0}
            } else {
                isConfirm = confirm("Are you sure you want to mark this as vulnerable?");
                stat = {"status" : 1}
            }

            if (action == "further") {
                url = this.$server + 'organisation/'+ this.$route.params.org_id +'/project/'+  me.$route.params.prod_id +'/report/' + me.report_id + '/further/' + id + '/status';
            }

            if (isConfirm) {
                axios({
                    method: 'put',
                    url: url,
                    data: stat
               })
                .then(res => {
                    if (res.data.success) {
                        me.init();
                        me.$swal({
                           title: res.data.message
                       });
                    }
                });
            }
        },

        resolved: function() {
            var isConfirm = false;
            var stat = {"status" : 0};
            const me = this;
            if (this.report.status == 1) {
                isConfirm = confirm("Are you sure you want to mark this as resolved?");
            } else {
                isConfirm = confirm("Are you sure you want to open this as report?");
                stat = {"status" : 1}; // open report
            }

            if (isConfirm) {
                axios({
                    method: 'put',
                    url: this.$server + 'organisation/'+ this.$route.params.org_id +'/project/'+  me.$route.params.prod_id +'/report/' + me.$route.params.report_id + '/status',
                    data: stat
               })
                .then(res => {
                    if (res.data.success) {
                        me.init();
                        me.$swal({
                           title: res.data.message
                       });
                    }
                });
            }
        }

     }
}
</script>
<style>
    .modal-backdrop.show {
        z-index: 500;
    }
</style>